export default __webpack_public_path__ + "static/media/DEI_OLD.6d44cdeb.png";